import { render, staticRenderFns } from "./TrainingHistoryView.vue?vue&type=template&id=4cd4ddd4&scoped=true"
import script from "./TrainingHistoryView.vue?vue&type=script&lang=js"
export * from "./TrainingHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4ddd4",
  null
  
)

export default component.exports